import { SvgIconType } from '@integration-app/react'
import { DataSchema } from '@integration-app/sdk'
import { useToggle } from 'usehooks-ts'

import { FieldPropertiesModal } from './PropertiesModal'
import { ActionBar } from '../Row/ActionBar'

type FieldActionBarProps = {
  onDelete?: () => void

  name?: string
  schema?: DataSchema
  onDefaultValueChange?: (value: any) => void
  isRequired?: boolean
  propertiesSchema?: DataSchema
  properties?: any
  onPropertiesChange?: (value: any) => void
  onRequiredChange?: (value: boolean) => void
}

export function FieldActionBar({
  onDelete,
  name,
  schema,
  isRequired,
  propertiesSchema,
  properties,
  onPropertiesChange,
  onRequiredChange,
}: FieldActionBarProps) {
  const [openProperties, toggleOpenProperties, setOpenProperties] =
    useToggle(false)

  const showConfigButton = Boolean(
    schema && propertiesSchema && onPropertiesChange,
  )

  const buttons: JSX.Element[] = []

  if (showConfigButton) {
    buttons.push(
      <ActionBar.GenericButton
        key={'onProperties'}
        onClick={toggleOpenProperties}
        iconType={SvgIconType.Settings}
        tooltip={'Properties'}
      />,
    )
  }

  if (onDelete) {
    buttons.push(<ActionBar.DeleteButton key={'onDelete'} onClick={onDelete} />)
  }

  return buttons.length ? (
    <>
      <ActionBar>{buttons}</ActionBar>
      {showConfigButton && (
        <FieldPropertiesModal
          open={openProperties}
          onOpenChange={({ open }) => setOpenProperties(open)}
          name={name}
          schema={schema}
          /* FIXME: strictNullCheck temporary fix */
          // @ts-expect-error TS(2322): Type 'DataSchema | undefined' is not assignable to... Remove this comment to see the full error message
          propertiesSchema={propertiesSchema}
          /* FIXME: strictNullCheck temporary fix */
          // @ts-expect-error TS(2322): Type '((value: any) => void) | undefined' is not a... Remove this comment to see the full error message
          onPropertiesChange={onPropertiesChange}
          propertiesValue={properties}
          /* FIXME: strictNullCheck temporary fix */
          // @ts-expect-error TS(2322): Type '((value: boolean) => void) | undefined' is n... Remove this comment to see the full error message
          onRequiredChange={onRequiredChange}
          /* FIXME: strictNullCheck temporary fix */
          // @ts-expect-error TS(2322): Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
          isRequired={isRequired}
        />
      )}
    </>
  ) : null
}
